import React,{useState, useEffect}  from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Cppsidebar';
import { Helmet } from "react-helmet";
import Button from 'react-bootstrap/Button'
function Cforloop(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
   
      <Sides/>
       <Helmet>
 
 <title>For loop in c++ tutorial For Beginners</title>
 <meta name="description" content="for loop in c++ tutorial for beginners.The body of the loop must be executed until the given condition is false, CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners" />
 <meta name="keywords" content="codeexampler,C++ for loop tutorial,programming language,tutorial for begineers,learn code in free,c++ programming tutorial for beginners,learn code in free online,cpp for loop,c++ for loop programs,programming in c++ for loop,c++ for loop syntax,cpp foreach loop,c++ for loop break,c++ for loop continue,cpp for loop increment,cpp for loop without braces" />
 <link rel="canonical" href="https://www.codeexampler.com/cpp-for-loop" />
 </Helmet>
 <div className='lg:pl-56'>
    <h1 className="m-4 mh1">For loop Statement in c++</h1>
    <div className="first">
        <a href="/cpp-do-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-break">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">For loop in c++:
</h2>

<p className="mt-4 para">1, The body of the loop must execute until the given condition is false<br/>
2, In  for loop, Semicolon use <br/>
3, This for loop uses to repeat a particular piece of code for a fixed no of times<br/>
</p>


<h2 className='head3'>For loop Syntax in C++</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">{"\n"}
            {"\n"}{"\n"}
            <span className="qwerty-4">For </span>
            <span className="qwerty-3">(</span>
            <span className="qwerty-9"> initialization; condition; iteration </span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-10">Statement sequence </span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>





<h2 className='headings'>Q-Write a Program to print a number from 1 to 10 in for loop?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int  </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-5">for </span>
            <span className="qwerty-3"> ( </span>
              <span className="qwerty-4">i </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty-10">1 </span>
              <span className="qwerty-3">; </span>
              <span className="qwerty-4">i </span>
              <span className="qwerty-3"> &#60; = </span>
              <span className="qwerty-10">10 </span>
              <span className="qwerty-3">; </span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-3">++ </span>
            <span className="qwerty-3">)</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
            <span className="qwerty-10"> i </span>
            <span className="qwerty-3">&#60;&#60; "</span>
            <span className="qwerty-10"> \n </span>
            <span className="qwerty-3">" ;</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
            {"\n"}{"\n"}
              <span className="qwerty-10">1 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">2 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">3 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">4 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">5 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">6 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">7 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">8 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">9 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">10 </span>
            
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


<h2 className="mt-4 mh2">Important:</h2>
<p className="mt-4 para">When you print a no into a different column so use (\n).
</p>



<h2 className='headings'>Q-Write a Program to print a number from 2 to 11 in for loop?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int  </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-5">for</span>
            <span className="qwerty-3"> ( </span>
              <span className="qwerty-10">i</span>
              <span className="qwerty-3"> =</span>
              <span className="qwerty-10"> 1</span>
              <span className="qwerty-3">; </span>
              <span className="qwerty-10">i</span>
              <span className="qwerty-4"> &#60; </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty-10">10 </span>
              <span className="qwerty-3">; </span>
              <span className="qwerty-4">cout</span>
              <span className="qwerty-3"> &#60;&#60;</span>
              <span className="qwerty-10"> i </span>
              <span className="qwerty-3"> &#60;&#60;" </span>
            <span className="qwerty-4">\n </span>
            <span className="qwerty-3">")</span>
            {"\n"}{"\n"}
            <span className="qwerty-5">i </span>
            <span className="qwerty-3">++ ;</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"}{"\n"}
              <span className="qwerty-10">2 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">3 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">4 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">5 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">6 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">7 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">8 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">9 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">10 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">11 </span>
              {"\n"}{"\n"}
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>



<Card className='inde' border='primary m-4'>
  <Card.Header as="h5">Q-Write a Program to print a name when a program is complete?
</Card.Header>
  <Card.Body>
    <Card.Text>
#include &#60;iostream&#62;<br/>
using namespace std;<br/><br/>
int main ( )<br/>
&#123;<br/>
int i;<br/>
for(i=1;i&#60;=10;i++)<br/>
&#123;<br/>
  cout&#60;&#60;i&#60;&#60;"\n";<br/>
  &#125;<br/>
  cout&#60;&#60;"Code exampler";<br/>
  &#125;<br/>

    </Card.Text>
  </Card.Body>
  <Card.Footer>Output-<br/>1<br/>
2<br/>
3<br/>
4<br/>
5<br/>
6<br/>
7<br/>
8<br/>
9<br/>
10<br/>
code Exampler</Card.Footer>
</Card>



<h2 className='headings'>Q-Write a Program to print a name again in for loop?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int  </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-5">for</span>
            <span className="qwerty-3"> ( </span>
              <span className="qwerty-10">i</span>
              <span className="qwerty-3"> =</span>
              <span className="qwerty-10"> 1</span>
              <span className="qwerty-3">; </span>
              <span className="qwerty-10">i</span>
              <span className="qwerty-4"> &#60; </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty-10">10 </span>
              <span className="qwerty-3">; </span>
              <span className="qwerty-10"> i </span>
            <span className="qwerty-3">++)</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; </span>
            <span className="qwerty-10">i</span>
            <span className="qwerty-3">; </span>
            {"\n"}{"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; " </span>
            <span className="qwerty-10">Ram-Ram </span>
            <span className="qwerty-3">" &#60;&#60; "</span>
            <span className="qwerty-10"> \n</span>
            <span className="qwerty-3"> ";</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"}{"\n"}
            <span className="qwerty-10">1 </span>
              <span className="qwerty-5">Ram Ram </span>
              {"\n"}{"\n"} 
              <span className="qwerty-10">2 </span>
              <span className="qwerty-5">Ram Ram </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">3 </span>
              <span className="qwerty-5">Ram Ram </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">4 </span>
              <span className="qwerty-5">Ram Ram </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">5 </span>
              <span className="qwerty-5">Ram Ram </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">6 </span>
              <span className="qwerty-5">Ram Ram </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">7 </span>
              <span className="qwerty-5">Ram Ram </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">8 </span>
              <span className="qwerty-5">Ram Ram </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">9 </span>
              <span className="qwerty-5">Ram Ram </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">10 </span>
              <span className="qwerty-5">Ram Ram </span>
              {"\n"}
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


<h2 className='headings'>Q-Write a Program to combine a no and name in for loop?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int  </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-5">for</span>
            <span className="qwerty-3"> ( </span>
              <span className="qwerty-10">i</span>
              <span className="qwerty-3"> =</span>
              <span className="qwerty-10"> 1</span>
              <span className="qwerty-3">; </span>
              <span className="qwerty-10">i</span>
              <span className="qwerty-4"> &#60; </span>
              <span className="qwerty-3">= </span>
              <span className="qwerty-10">10 </span>
              <span className="qwerty-3">; </span>
              <span className="qwerty-10"> i </span>
            <span className="qwerty-3">++)</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; " </span>
            <span className="qwerty-10">Ram-Ram </span>
            <span className="qwerty-3">" &#60;&#60; </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">" &#60;&#60; "</span>
            <span className="qwerty-10"> \n</span>
            <span className="qwerty-3"> ";</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="head3">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code className="python hljs">
            {"\n"}{"\n"}
              <span className="qwerty-5">Hello Ram </span>
              <span className="qwerty-10">1 </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">Hello Ram </span>
              <span className="qwerty-10">2 </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">Hello Ram </span>
              <span className="qwerty-10">3 </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">Hello Ram </span>
              <span className="qwerty-10">4 </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">Hello Ram </span>
              <span className="qwerty-10">5 </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">Hello Ram </span>
              <span className="qwerty-10">6 </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">Hello Ram </span>
              <span className="qwerty-10">7 </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">Hello Ram </span>
              <span className="qwerty-10">8 </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">Hello Ram </span>
              <span className="qwerty-10">9 </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">Hello Ram </span>
              <span className="qwerty-10">10 </span>
              {"\n"}{"\n"}
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>




<h2 className='headings'>Q-Write a Program to range started from 2 and finish on 8 in for loop?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">i </span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">first </span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">last </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; " </span>
              <span className="qwerty-10">enter</span>
              <span className="qwerty-4"> first</span>
              <span className="qwerty-10"> no</span>
              <span className="qwerty-10">\n</span>
              <span className="qwerty-3"> "; </span>
            {"\n"}{"\n"}
            <span className="qwerty-7">cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty-4">first</span>
            <span className="qwerty-3"> ;</span>
            {"\n"}{"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; " </span>
              <span className="qwerty-10">enter</span>
              <span className="qwerty-4"> last</span>
              <span className="qwerty-10"> no</span>
              <span className="qwerty-10">\n</span>
              <span className="qwerty-3"> "; </span>
            {"\n"}{"\n"}
            <span className="qwerty-7">cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty-4">last</span>
            <span className="qwerty-3"> ;</span>
            {"\n"}{"\n"}
            <span className="qwerty-6">for </span>
            <span className="qwerty-3">(</span>
              <span className="qwerty-10"> i</span>
              <span className="qwerty-3"> =</span>
              <span className="qwerty-4"> first</span>
              <span className="qwerty-3"> ; </span>
              <span className="qwerty-10">i</span>
              <span className="qwerty-3">&#60;</span>
              <span className="qwerty-3"> =</span>
              <span className="qwerty-4"> last</span>
              <span className="qwerty-3"> ; </span>
              <span className="qwerty-10">i</span>
              <span className="qwerty-3"> ++) </span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; " </span>
              <span className="qwerty-10">Number is</span>
              <span className="qwerty-3"> &#60;&#60; "</span>
              <span className="qwerty-10"> i </span>
              <span className="qwerty-3">&#60;&#60; " </span>
              <span className="qwerty-10">\n</span>
              <span className="qwerty-3"> "; </span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
            {"\n"}{"\n"}
            <span className="qwerty-5">enter </span>
            <span className="qwerty-4">first </span>
            <span className="qwerty-5">no </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">  2 </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">enter </span>
              <span className="qwerty-4">last </span>
              <span className="qwerty-5">no </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">  8 </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">Number is </span>
              <span className="qwerty-10">2 </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">Number is </span>
              <span className="qwerty-10">3 </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">Number is </span>
              <span className="qwerty-10">4 </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">Number is </span>
              <span className="qwerty-10">5 </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">Number is </span>
              <span className="qwerty-10">6 </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">Number is </span>
              <span className="qwerty-10">7 </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">Number is </span>
              <span className="qwerty-10">8 </span>
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>





<h2 className='headings'>Q-Write a Program to favicon series in for loop?</h2>
      <div style={{ background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code >{"\n"}
            <span className="qwerty-7">#include </span>
            <span className="qwerty-3">&#60;</span>
            <span className="qwerty-5">iostream</span>
            <span className="qwerty-3">&#62; </span>
            {"\n"}{"\n"}
            <span className="qwerty-2">using </span>
            <span className="qwerty-5">namespace </span>
            <span className="qwerty-2">std; </span>
            {"\n"}{"\n"}
            <span className="qwerty-11">int </span>
            <span className="qwerty-10">main</span>
            <span className="qwerty-3"> ()</span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
            <span className="qwerty-7">int</span>
            <span className="qwerty-4"> a</span>
            <span className="qwerty-3"> =</span>
            <span className="qwerty-10"> 0 </span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">b </span>
            <span className="qwerty-3">= </span>
            <span className="qwerty-10">1 </span>
            <span className="qwerty-3">, </span>
            <span className="qwerty-4">c</span>
            <span className="qwerty-3"> , </span>
            <span className="qwerty-4">i </span>
            <span className="qwerty-3">;</span>
            {"\n"}{"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; " </span>
              <span className="qwerty-10">enter</span>
              <span className="qwerty-4"> first</span>
              <span className="qwerty-10"> no </span>
              <span className="qwerty-10">\n</span>
              <span className="qwerty-3"> "; </span>
            {"\n"}{"\n"}
            <span className="qwerty-7">cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty-4">a</span>
            <span className="qwerty-3"> ;</span>
            {"\n"}{"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60; " </span>
              <span className="qwerty-10">enter</span>
              <span className="qwerty-4"> last</span>
              <span className="qwerty-10"> no </span>
              <span className="qwerty-10">\n</span>
              <span className="qwerty-3"> "; </span>
            {"\n"}{"\n"}
            <span className="qwerty-7">cin </span>
            <span className="qwerty-3">&#62;&#62; </span>
            <span className="qwerty-4">b</span>
            <span className="qwerty-3"> ;</span>
            {"\n"}{"\n"}
            <span className="qwerty-6">for </span>
            <span className="qwerty-3">(</span>
              <span className="qwerty-10"> i</span>
              <span className="qwerty-3"> =</span>
              <span className="qwerty-4"> 1</span>
              <span className="qwerty-3"> ; </span>
              <span className="qwerty-10">i</span>
              <span className="qwerty-3">&#60;</span>
              <span className="qwerty-3"> =</span>
              <span className="qwerty-4"> 10</span>
              <span className="qwerty-3"> ; </span>
              <span className="qwerty-10">i</span>
              <span className="qwerty-3"> ++) </span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#123; </span>
            {"\n"}{"\n"}
              <span className="qwerty-10">c</span>
              <span className="qwerty-3"> =</span>
              <span className="qwerty-10"> a</span>
              <span className="qwerty-3"> +</span>
              <span className="qwerty-10"> b</span>
              <span className="qwerty-3"> ; </span>
            {"\n"}{"\n"}
            <span className="qwerty-5">cout </span>
            <span className="qwerty-3">&#60;&#60;</span>
              <span className="qwerty-10"> c</span>
              <span className="qwerty-3"> ; </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">a</span>
              <span className="qwerty-3"> =</span>
              <span className="qwerty-10"> b</span>
              <span className="qwerty-3"> ; </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">b</span>
              <span className="qwerty-3"> =</span>
              <span className="qwerty-10"> c</span>
              <span className="qwerty-3"> ; </span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
            <span className="qwerty-3">&#125; </span>
            {"\n"}{"\n"}
          </code>
        </pre>
      </div>

      <div>
        <h3 className="headings">Output</h3>
        <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
          <pre style={{ maxHeight: '500vh' }}>
            <code >
            {"\n"}{"\n"}
            <span className="qwerty-5">enter </span>
            <span className="qwerty-4">first </span>
            <span className="qwerty-5">no </span>
            <span className="qwerty-10">2 </span>
              {"\n"}{"\n"}
              <span className="qwerty-5">enter </span>
              <span className="qwerty-4">last </span>
              <span className="qwerty-5">no </span>
              <span className="qwerty-10">5 </span>
              {"\n"}{"\n"}
              <span className="qwerty-10">71219315081131212343555</span>
              {"\n"}
            
              {"\n"}</code>{"\n"}</pre>
        </div>
      </div>


<h1 className="mt-5">  </h1>


<div className="back">
        <a href="/cpp-do-while">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/cpp-break">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Cforloop;